
import { serviceName } from '../resources/serviceConstants';
import {
  CERTIFICATION_CATEGORY_MASTER,
} from '../resources/endPoint';

export const getCertificationsCategoryList = () => {
  return {
    url: CERTIFICATION_CATEGORY_MASTER,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.CERTIFICATIONS_MS,
  };
};

export const updateCategory = (data) => {
  return {
    url: CERTIFICATION_CATEGORY_MASTER,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.CERTIFICATIONS_MS,
  };
};

export const addCategory = (data) => {

  return {
    url: CERTIFICATION_CATEGORY_MASTER,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.CERTIFICATIONS_MS,
  };
};

export const categoryList = () => {
  const config = {
    url: CERTIFICATION_CATEGORY_MASTER,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.CERTIFICATIONS_MS,
  };
  return { ...config};
};
